export interface IWaveSpectrumQuery {
    mappingId: number
    timeRange?: [Date, Date]

    // 温度
    companyId: null
    areaId: null
}


/**
 * $t('enum.E_WaveTabs.TrendWave')
 * $t('enum.E_WaveTabs.TimeDomainWave')
 * $t('enum.E_WaveTabs.FrequencySpectrum')
 * $t('enum.E_WaveTabs.Waterfall')
 * $t('enum.E_WaveTabs.Temperature')
 * $t('enum.E_WaveTabs.MultipleIndicatorsTrend')
 * $t('enum.E_WaveTabs.Cepstrum')
 * $t('enum.E_WaveTabs.AxisOrbit')
 * $t('enum.E_WaveTabs.VoicePrint')
 * $t('enum.E_WaveTabs.OrderAnalysis')
 */
export enum E_WaveTabs {
    TrendWave = 0,
    TimeDomainWave = 1,
    FrequencySpectrum = 2,
    Waterfall = 3,
    Temperature = 4,
    MultipleIndicatorsTrend = 5,
    /**
     * 倒谱图
     */
    Cepstrum = 6,
    /**
     *运行轨迹
     */
    AxisOrbit = 7,
    /**
     * 声纹
     */
    VoicePrint = 9,
    /*
     * 阶次分析
     */
    OrderAnalysis = 8,
}
